// Định dạng tiền tệ dùng chung cho module Kế toán.
// Phân cách hàng nghìn bằng dấu phẩy để dễ đọc.

// Hiển thị số tiền có phân cách hàng nghìn khi nhập (giữ dấu âm và phần thập phân đang gõ).
export const groupMoney = (v) => {
  if (v === "" || v == null) return "";
  const s = String(v).replace(/,/g, "");
  const neg = s.startsWith("-");
  const abs = neg ? s.slice(1) : s;
  const parts = abs.split(".");
  const intPart = (parts[0] || "").replace(/\D/g, "");
  const grouped = intPart.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  const dec = parts.length > 1 ? "." + parts[1].replace(/\D/g, "") : "";
  return (neg ? "-" : "") + grouped + dec;
};

// Bỏ dấu phân cách để lưu giá trị số thuần (chuỗi).
export const unformatMoney = (str) => (str == null ? "" : String(str).replace(/,/g, ""));

// Chuỗi tiền (có/không phẩy) -> số để gửi payload.
export const toMoneyNumber = (v) => {
  const n = Number(unformatMoney(v));
  return Number.isFinite(n) ? n : 0;
};

// Hiển thị số tiền kèm hậu tố " đ", phân cách bằng dấu phẩy.
export const formatVND = (v) => `${Number(v || 0).toLocaleString("en-US")} đ`;

// Hiển thị số (không hậu tố) — dùng cho trục biểu đồ / cột số.
export const formatMoney = (v) => Number(v || 0).toLocaleString("en-US");
